import { MapElement as CanvasApiMapElement } from '@spiaggeit/map-canvas'
import { Vector2d, Direction } from '@spiaggeit/spit-core'
import { ResponseBase } from './http'

export interface MapResponseElement {
  sid: number
  t: string
  pX: number
  pY: number
  n: string
  pl: number
  plo: number
  bgc: string
  o: boolean
  s: number
  a: boolean
  ed?: Direction // elment direction
  et: string // element type
  er: number // rotation
  ew?: number // width
  eh?: number // height
  url: string
  mlt?: string
  zi: number
  st: boolean
}

export interface BoundingBox2d {
  min: Vector2d
  max: Vector2d
  size: Vector2d
  halfSize: Vector2d
  center: Vector2d
}

export interface MapResponse {
  result: {
    backgroundUrl: string | null
    elements: MapResponseElement[]
    height: number
    width: number
    bestQuadrant?: BoundingBox2d | null
  }
}

export enum MapSetupItemKeyName {
  BED = 'b',
  CHAIR = 'c',
  COMBINED_LIMIT = 'i',
  DECK_CHAIR = 'd',
  MAXI_BED = 'm',
}

export type SectorHeader = {
  name: string
  description: string
  image: string | null
  licenseCode: string
  enabled: boolean
  id: number
  oldId: number
}

export type SectorDetail = {
  sectorId: number
  type: SectorDetailType
  keyName: MapSetupItemKeyName
  keyType: APISectorDetailKeyType
  keyValue: number
  id: number
}

export type Sector = {
  header: SectorHeader
  details: SectorDetail[]
  canBeDeleted: boolean
}

export enum SectorDetailType {
  OFFLINE = 'offline',
  ONLINE = 'online',
}

export enum APISectorDetailKeyType {
  DEFAULT = 'd',
  MAX = 'max',
  MIN = 'min',
}

export interface MapSetupItem {
  keyName: MapSetupItemKeyName
  label: string
  [APISectorDetailKeyType.MIN]: number
  [APISectorDetailKeyType.MAX]: number
  [APISectorDetailKeyType.DEFAULT]: number
  icon: string
  sectorId: number
}

export type MapElementWithSectorId = CanvasApiMapElement & {
  sectorId?: number
  /** Spot availability from the map API before warehouse adjustments */
  apiAvailable?: boolean
}

interface Warehouse {
  availabilities: [] | Record<number, WarehouseSetup>
  id: number
  sectors: number[]
}

export interface WarehouseSetup {
  beds: number
  chairs: number
  deckChairs: number
  maxiBeds: number
}

export type WarehousesResponse = ResponseBase<{
  warehouses: Warehouse[]
}>
